import { createFalconTaskSocket, falconEndpoints } from '@om1/falcon-api'

export const taskSocket = createFalconTaskSocket(falconEndpoints.task.path)
